__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "rw-audit-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.4.0", () => (Promise.all([__webpack_require__.e(447), __webpack_require__.e(59)]).then(() => (() => (__webpack_require__(5447))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(604), __webpack_require__.e(246), __webpack_require__.e(379)]).then(() => (() => (__webpack_require__(6604))))));
			register("antd", "5.26.7", () => (Promise.all([__webpack_require__.e(738), __webpack_require__.e(206), __webpack_require__.e(59), __webpack_require__.e(559), __webpack_require__.e(324)]).then(() => (() => (__webpack_require__(4206))))));
			register("history", "5.3.0", () => (__webpack_require__.e(915).then(() => (() => (__webpack_require__(5296))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(6178))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(59)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(166), __webpack_require__.e(59), __webpack_require__.e(559), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(2166))))));
			register("react-router-dom", "6.13.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(59)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("rw-themes-common", "4.0.2", () => (Promise.all([__webpack_require__.e(417), __webpack_require__.e(59), __webpack_require__.e(559), __webpack_require__.e(635), __webpack_require__.e(370)]).then(() => (() => (__webpack_require__(4417))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};